<template>
  <div class="page-container">
    <van-nav-bar left-arrow fixed :title="detail.name" @click-left="goBack" :z-index="10"></van-nav-bar>
    <!-- 头部 -->
    <div class="detail">
      <!-- 头部图片 -->
      <div class="header">
        <img v-if="detail.imgDetailPath" fit="cover" :src="detail.imgDetailPath" alt="债权拍卖" />
        <img v-else fit="cover" src="../../assets/img/invest/auction_detail_bg.png" alt="债权拍卖" />
      </div>
      <!-- 债权详情信息 -->
      <div class="detail-contain">
        <div class="contain">
          <div class="title">{{ detail.name }}</div>
          <div>
            <!-- v-if="
                detail.attachLabel &&
                (detail.hasNewYearActivity || detail.purchaseActivity) &&
                detail.activityDiscount
              " -->
            <van-tag v-if="detail.attachLabel" plain color="#ff9900">{{
              detail.attachLabel
            }}</van-tag>
          </div>
          <div class="bottom-bg">
            <div class="left">
              <div class="left-t title1">
                <span>预期年化折扣率：</span>
                <span class="value" v-if="rateInterval.minRate === rateInterval.maxRate">{{ rateInterval.minRate }}%</span>
                <span class="value" v-else>{{ rateInterval.minRate }}%~{{ rateInterval.maxRate }}%</span>
              </div>
              <div class="left-t1 title1">委托开始时间</div>
              <div class="title2">
                {{ dateFormat(detail.beginTime, "MM-DD HH:mm") }}
              </div>
            </div>
            <div class="right">
              <div class="right-t title1">
                <span>债权期限：</span>
                <span class="value">{{ detail.investDuration }}天</span>
              </div>
              <div class="right-t1 title1">委托结束时间</div>
              <div class="title2">
                {{ dateFormat(detail.endTime, "MM-DD HH:mm") }}
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div class="cell-contain" v-if="detail.protocolList && detail.protocolList.length > 0">
            <van-cell v-for="(n, i) of detail.protocolList" :key="'protocol-' + i" class="item" :title="n.name" :to="{
                name: 'agreement-trade',
                query: {
                  title: n.name,
                  pushType: 2,
                  productId: productId,
                  id: n.id,
                  type: '1'
                }
              }" is-link></van-cell>
          </div>
          <!-- 拍品相关文件  -->
          <div style="margin-top: -15px" class="cell-contain" v-if="
              detail.auctionContentFiles &&
              detail.auctionContentFiles.length > 0
            ">
            <van-cell v-for="(item, i) of detail.auctionContentFiles" :key="i" class="item" :title="item.name" :to="{
                name: 'agreement/pdfDetail',
                query: { item: { url: item.filePath } }
              }" is-link></van-cell>
          </div>
        </div>
      </div>
      <!-- 预约截止日 -->
      <div class="time">
        <div class="time-box">
          <!-- top -->
          <div class="top">
            <div class="top-left">
              <div class="a">委托截止日</div>
              <div class="img">
                <img src="../../assets/img/detail/suo.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.endTime, "YYYY-MM-DD") }}
              </div>
            </div>
            <div class="r">
              <img src="../../assets/img/detail/right.png" alt />
            </div>
            <div class="top-left">
              <div class="a">预计成交日</div>
              <div class="img">
                <img src="../../assets/img/detail/naozhong.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.valueDate, "YYYY-MM-DD") }}
              </div>
            </div>
            <div class="r">
              <img src="../../assets/img/detail/right.png" alt />
            </div>
            <div class="top-left">
              <div class="a">拍品到期日</div>
              <div class="img">
                <img src="../../assets/img/detail/money.png" alt />
              </div>
              <div class="b">
                {{ dateFormat(detail.dueDate, "YYYY-MM-DD") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 拍品相关文件  -->
      <!-- <div
        class="auction-file"
        v-if="
          detail.auctionContentFiles && detail.auctionContentFiles.length > 0
        ">
        <div id="title2">拍品相关文件</div>
        <div
          class="file-box"
          v-for="(item, i) of detail.auctionContentFiles"
          :key="i">
          <van-cell
            :title="item.name"
            class="item"
            :to="{
              name: 'agreement/pdfDetail',
              query: { item: { url: item.filePath } }
            }"
            is-link />
        </div>
      </div> -->
      <!-- 资产特点-->
      <div class="trait" v-if="characteristicArray.length > 0">
        <div id="title1">资产特点</div>
        <div class="trait-box">
          <template v-for="(n, i) of characteristicArray">
            <div v-if="n.type == 1" :key="i">
              <div class="box-title">{{ n.key }}</div>
              <div class="center">
                <div class="center-box">
                  <div v-for="(obj, idx) of n.subTitle" :key="idx">
                    <img src="../../assets/img/detail/dui.png" alt />
                    <span> {{ obj }}</span>
                  </div>
                </div>
              </div>
            </div>
            <img v-if="n.type == 3" :src="n.val" :key="i" style="width: 80%" />
            <video v-if="n.type == 4" :src="n.val" :key="i" controls="controls" playsinline="true" autoplay="autoplay" style="width: 100%"></video>
          </template>
        </div>
      </div>
      <!-- 拍品资产档案  -->
      <div class="file" v-if="detail.assetFilesList">
        <div id="title2">拍品资产档案</div>
        <div class="file-box">
          <van-cell v-for="(n, i) of detail.assetFilesList" :key="'assetFile-' + i" :title="n.title" class="item" :clsaa="detail.assetFilesList.length - 1 === i ? 'last' : ''" :to="{
              name: 'agreement/pdfDetail',
              query: { item: n }
            }" is-link />
        </div>
      </div>
      <!-- 常见问题 -->
      <div class="problem">
        <div id="title3">常见问题</div>
        <div class="problem-box">
          <van-collapse v-model="activeName" accordion>
            <template v-if="detail.qalist">
              <van-collapse-item v-for="(n, i) of detail.qalist" :name="i" :key="`qa-${i}`">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    {{ n.question }}
                  </div>
                </template>
                <div class="text">{{ n.answer }}</div>
              </van-collapse-item>
            </template>
            <template v-else>
              <van-collapse-item name="0">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    “{{ detail.typeName }}”资产转让系列投资人的收益方式是什么？
                  </div>
                </template>
                <div class="text">
                  到期一次性兑付，“{{
                    detail.typeName
                  }}”资产转让系列在转让到期日由转让/回购方进行溢价回购，相关投资本金和收益在不晚于资产转让到期日后三个工作日内兑付投资人。
                </div>
              </van-collapse-item>
              <van-collapse-item name="1">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    可以要求回购方提前回购吗？
                  </div>
                </template>
                <div class="text">
                  在投资人受让资产收益起算日起，至资产转让到期日止，投资人不得要求提前提取受让资金。
                </div>
              </van-collapse-item>
              <van-collapse-item name="2">
                <template #title>
                  <div class="first">
                    <img src="../../assets/img/detail/wenhao.png" alt />
                    “{{
                      detail.typeName
                    }}”资产转让系列在投资开放期内是否可以撤销投资？
                  </div>
                </template>
                <div class="text">
                  投资人在确认受让该资产后，资金被冻结，即进入“申请中”状态，资金冻结期间投资人是不能撤销投资，申请受让前请谨慎考虑！
                </div>
              </van-collapse-item>
            </template>
          </van-collapse>
        </div>
      </div>
      <!-- 拍卖专区 -->
      <div class="auctionarea" v-if="detail.auctionProductList">
        <div id="title4">拍卖专区</div>
        <div class="auctionarea-box">
          <van-cell class="item" v-for="(n, i) of detail.auctionProductList" :key="'auctionarea' + i">
            <div class="contain">
              <div class="left">
                <span class="amount">{{ n.name }}</span>
                <span class="round1">&nbsp;&nbsp;&nbsp;预期年化折扣率</span>
                <span class="round2">{{ n.rate }}%</span>
              </div>
              <div class="right">
                <van-stepper class="stepper" v-model="n.selectNumber" :disabled="detail.isFull" :min="0" :max="n.residueNumber" button-size="20" :disable-input="true" default-value="0" @change="onchanged(n)" />
                <div class="num">剩余{{ n.residueNumber }}份</div>
              </div>
            </div>
          </van-cell>
        </div>
      </div>
    </div>
    <!-- 第八部分 立即购买-->
    <div class="buy-bg" v-if="detail.isFull == false">
      <div class="totale-amount">总计：{{ totaleAmount }}元</div>
      <van-button v-if="totaleAmount > 0" @click="onBuy" v-preventReClick class="buy" :disabled="totaleAmount > 0 ? false : true">下一步</van-button>
      <van-button v-else class="buy-no" @click="onNoBuy">下一步</van-button>
    </div>
    <!-- 第九部分 风险测评 -->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Cell,
  Collapse,
  CollapseItem,
  Popup,
  Toast,
  Stepper,
  Dialog,
  Tag
} from "vant"
import * as ProductApi from "@/api/product"
import moment from "moment"
import { mapGetters, mapMutations } from "vuex"
import session from "@/utils/session"

export default {
  name: "claimDetail",
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Popup.name]: Popup,
    [Stepper.name]: Stepper,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data: () => ({
    activeName: "1",
    canbuy: true,
    productId: null,
    detail: {},
    assessShow: false,
    resetAssessShow: false,
    loading: false,
    totaleAmount: 0, // 选择拍品总金额
    auctionOrderList: [] //选择拍品集合
  }),
  beforeRouteEnter(to, { }, next) {
    let p1 = ProductApi.detail(to.query.productId)
    let p2 = ProductApi.canbuy(to.query.productId)
    Promise.all([p1, p2]).then((data) => {
      next((vm) => {
        vm.setData(data)
      })
    })
  },
  beforeRouteUpdate(to, { }, next) {
    let p1 = ProductApi.detail(to.query.productId)
    let p2 = ProductApi.canbuy(to.query.productId)
    Promise.all([p1, p2]).then((data) => {
      this.setData(data)
      next()
    })
  },
  methods: {
    // 拍品选择改变
    onchanged(item) {
      this.totaleAmount = 0
      this.auctionOrderList = []
      this.detail.auctionProductList.forEach((n) => {
        if (n.selectNumber > 0) {
          this.totaleAmount += n.selectNumber * n.auctionAmount
          let map = {
            auctionId: n.id,
            amount: n.auctionAmount,
            auctionCount: n.selectNumber,
            rate: n.rate
          }
          this.auctionOrderList.push(map)
        }
      })
    },
    //初始化接口赋值
    setData(data) {
      console.log("data == %O", data)
      this.detail = data[0]
      this.productId = this.detail.id

      if (this.detail.sold == 100 || this.detail.isFull) {
        this.canbuy = false
      }
      if (!data[1].canBuy) {
        this.canbuy = false
      }
      // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
      console.log("canbuy == " + data[1])
      if (this.onNormalLook()) {
        this.resetAssessShow =
          this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
        if (data[1].code == 3006) {
          this.assessShow = this.resetAssessShow == true ? false : true
        }
      }
      this.setShare()
    },
    //判断是否已经完成基本信息的操作
    onNormalLook() {
      if (this.userInfo.isAuthName) {
        if (this.userInfo.userLevel < 1) {
          session.setJson("cq", {
            productId: this.productId,
            target: "claimDetail"
          })
          this.assessShow = this.resetAssessShow == true ? false : true
          return false
        }
        //检测绑卡
        if (!this.userInfo.isBindCard) {
          session.setJson("cq", {
            productId: this.productId,
            target: "claimDetail"
          })
          this.$router.push({ name: "bindcard" })
          return false
        }
        return true
      } else {
        //未设置实名
        Dialog.alert({
          title: "温馨提示",
          message: "您还未实名，请先去实名认证？",
          confirmButtonText: "去实名",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            this.$router.push({ name: "realname" })
          })
          .catch(() => { })
        return false
      }
    },
    isAfter(time1, time2) {
      return moment(time1).isAfter(time2, "second")
    },
    onBuy() {
      //检测测评
      //forceAssess 是否强制评测
      //assessNum 已评测次数
      // if (this.userInfo.assessNum < 1 || this.userInfo.forceAssess) {
      if (this.onNormalLook()) {
        this._showLoading()
        ProductApi.canbuy(this.detail.id)
          .then((data) => {
            this._dismissLoading()
            if (data.canBuy) {
              // 清除本地缓存信息
              localStorage.removeItem("payForm")
              session.del("payForm")
              this.$router.push({
                name: "auctionBuying",
                query: {
                  productId: this.productId,
                  totaleAmount: this.totaleAmount,
                  auctionOrder: JSON.stringify(this.auctionOrderList)
                }
              })
            } else {
              this.canbuy = false
              Toast({
                message: data.msg || "资产已抢光"
              })
            }
          })
          .catch((e) => {
            this._dismissLoading()
            Toast(e.msg || e.message)
            // 3006 用户放弃签署 3007 用户和产品风险等级不匹配
            if (e.code == 3006) {
              this.assessShow = true
            }
          })
      }
    },
    onNoBuy() {
      this.$toast("请先选择需要购买的拍品")
    },
    goAssess() {
      session.set("productId", this.productId)
      this.$router.push({ path: "questions" })
    },
    goBack() {
      if (this.$route.query.share && this.$route.query.share.length > 0) {
        this.$router.push({ name: "home" })
      } else {
        this.goableBack()
      }
    },
    setShare() {
      if (this.detail.shareTitle && this.detail.shareTitle.length) {
        let sharepath = encodeURIComponent(
          `/detail?productId=${this.detail.id}&invite=${this.userInfo.custId}&chanlCode=${this.channel}&share=wx`
        )
        let share = {
          title: this.detail.shareTitle,
          desc: this.detail.shareDesc,
          link: `${process.env.VUE_APP_BASE_URL}?sharepath=${sharepath}`,
          invite: this.userInfo.custId
        }
        this.$emit("setShare", share)
      }
    },
    ...mapMutations(["setToken", "setUserInfoIsProm"])
  },
  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"]),
    // 资产特点
    characteristicArray() {
      if (this.detail.keyMap && this.detail.keyMap.length > 0) {
        const datas = this.detail.keyMap.filter((item) => item.type === 1) //只获取type == 1的集合
        // const datas = this.detail.keyMap
        datas.forEach((item) => {
          if (item.type === 1) {
            if (item.val.length && item.val.length > 0) {
              var obj = new Object()
              if (item.val.indexOf("\\n") > -1) {
                obj.datas = item.val.split("\\n")
              } else {
                obj.datas = item.val.split("\n")
              }
              item.subTitle = obj.datas
            }
          }
        })
        return datas
      }
      return []
    },
    // 收益率
    rateInterval: function () {
      if (this.detail.stairRate) {
        let minRate = this.detail.stairRate.rateOne,
          maxRate = this.detail.stairRate.rateFive
        return { minRate: minRate, maxRate: maxRate }
      } else {
        return { minRate: 0, maxRate: 0 }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background: #f1f5f8;
  padding-bottom: 40px;
}
.van-cell {
  padding: 0;
  width: auto;
}
.van-cell::after {
  left: 0;
  right: 0;
  border: none;
}
//详情
.detail {
  .header {
    // background-image: url(../../assets/img/detail/bjt.jpg);
    background-size: 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    height: 130px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .detail-contain {
    background-color: white;
    border-radius: 8px;
    margin: 10px;
    .contain {
      margin: 10px;
      .title {
        font-size: 15px;
        color: rgb(33, 33, 33);
        word-break: break-all;
        padding-top: 10px;
      }
      .bottom-bg {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        margin-bottom: 15px;
        .right {
          margin-right: 30px;
        }
        .left .left-t1 {
          margin-top: 15px;
        }
        .right .right-t1 {
          margin-top: 15px;
        }
        .title1 {
          font-size: 13px;
          color: rgb(150, 150, 150);
        }
        .value {
          font-size: 14px;
          color: rgb(229, 68, 22);
        }
        .title2 {
          font-size: 13px;
          color: rgb(57, 57, 57);
        }
      }
      .line {
        background-color: rgb(244, 244, 244);
        height: 1px;
      }
      .cell-contain {
        margin-top: 10px;
        padding-bottom: 15px;
        .item {
          height: 30px;
          font-size: 13px;
          color: rgb(128, 128, 128);
        }
      }
    }
  }
}
//预约截止日
.time {
  border-radius: 8px;
  margin: 10px;
  background-color: #fff;
  .time-box {
    margin: 0 18px;
    // top
    .top {
      display: flex;
      align-items: center;
      padding: 16px 0;
      .r {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        // border: 1px solid #000000;
        img {
          width: 22px;
        }
      }
      .top-left {
        flex: 2;
        // border: 1px solid #000000;
        .a {
          font-size: 14px;
          color: #404040;
          text-align: center;
        }
        .b {
          font-size: 12px;
          color: #999999;
          text-align: center;
        }
        .img {
          height: 39px;
          width: 39px;
          background-color: #fff0ea;
          border-radius: 50px;
          text-align: center;
          margin: 12px auto;
          // margin-left: 9px;

          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
}
//拍品相关文件
.auction-file {
  margin: 10px;
  background-color: #fff;
  border-radius: 8px;
  #title2 {
    padding: 15px 10px 0 10px;
    font-size: 15px;
    color: #333333;
    font-weight: 700;
  }
  .file-box {
    margin-top: 10px;
    padding-bottom: 15px;
    .item {
      margin: 0 10px;
      height: 30px;
      font-size: 13px;
      color: rgb(128, 128, 128);
    }
  }
}
//资产特点
.trait {
  margin: 0 10px;
  background-color: #fff;
  border-radius: 8px;
  #title1 {
    padding: 15px 10px 0 10px;
    font-size: 15px;
    color: #333333;
    font-weight: 700;
  }
  .trait-box {
    padding: 10px;
    padding-bottom: 15px;
    .box-title {
      margin-top: 20px;
      font-size: 13px;
      color: #fc6524;
    }
    :first-child .box-title {
      margin-top: 0;
    }
    .center {
      padding-top: 12px;
      .center-box {
        // border: 1px solid #000;
        img {
          width: 14px;
          height: 14px;
        }
        span {
          margin-left: 5px;
          font-size: 13px;
          color: #797979;
        }
      }
    }
    img {
      width: 100%;
      height: 138px;
      vertical-align: middle;
    }
  }
}
// 拍品资产档案
.file {
  margin: 10px;
  background-color: #fff;
  border-radius: 8px;
  #title2 {
    padding: 15px 10px 0 10px;
    font-size: 15px;
    color: #333333;
    font-weight: 700;
  }
  .file-box {
    margin-top: 10px;
    padding-bottom: 15px;
    .item {
      margin: 0 10px;
      height: 30px;
      font-size: 13px;
      color: rgb(128, 128, 128);
    }
  }
}
// 常见问题
.problem {
  margin: 10px;
  padding-bottom: 15px;
  background-color: #fff;
  border-radius: 8px;
  #title3 {
    padding: 15px 10px 0 10px;
    font-size: 15px;
    color: #333333;
    font-weight: 700;
  }
  .problem-box {
    padding: 15px 10px 0 10px;
    .van-hairline--top-bottom:after {
      border: none;
    }

    .first {
      font-size: 13px;
      color: #333333;
      font-weight: 700;
      letter-spacing: 0.5px;
      display: flex;
      padding: 5px 0;

      img {
        width: 14px;
        height: 14px;
        margin: 6px 8px 0 0;
      }
    }
    .text {
      padding: 16px 24px;
      font-size: 13px;
      color: #828282;
      letter-spacing: 0.5px;
    }
  }
}
//拍卖专区
.auctionarea {
  margin: 10px;
  background-color: #fff;
  border-radius: 8px;
  #title4 {
    padding: 15px 10px 0 10px;
    font-size: 15px;
    color: #333333;
    font-weight: 700;
  }
  .auctionarea-box {
    margin-top: 10px;
    padding-bottom: 15px;
    .item {
      margin: 0 10px;
      margin-bottom: 10px;
      color: rgb(128, 128, 128);
      background-color: rgb(230, 195, 157);
      border-radius: 8px;
      border: 2 solid rgb(245, 216, 188);
      // Firefox4.0-
      -moz-box-shadow: 2px 2px 10px rgb(245, 216, 188);
      // Safariand Google chrome10.0-
      -webkit-box-shadow: 2px 2px 10px rgb(245, 216, 188);
      // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
      box-shadow: 2px 2px 10px rgb(245, 216, 188);
      .contain {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        .left {
          margin-left: 10px;
          .amount {
            font-size: 14px;
            font-weight: 700;
            color: rgb(84, 62, 47);
          }
          .round1 {
            color: rgb(222, 50, 28);
          }
          .round2 {
            color: rgb(222, 50, 28);
            font-weight: 700;
          }
        }
        .right {
          margin-right: 30px;
          .stepper {
            margin-top: 15px;
            margin-bottom: 5px;
            height: 15px;
            color: white;
          }
          // ::v-deep 等价=== /deep/
          ::v-deep .van-stepper__minus {
            color: white;
            background-color: rgb(198, 151, 105);
            border-radius: 0;
          }
          ::v-deep .van-stepper__minus--disabled {
            color: white;
            background-color: rgb(212, 168, 123);
            border-radius: 0;
          }
          ::v-deep .van-stepper__plus {
            color: white;
            background-color: rgb(198, 151, 105);
            border-radius: 0;
          }
          ::v-deep .van-stepper__plus--disabled {
            color: white;
            background-color: rgb(212, 168, 123);
            border-radius: 0;
          }
          /deep/ .van-stepper__input {
            color: white;
            background-color: rgb(212, 168, 123);
          }
          .num {
            text-align: center;
            color: rgb(210, 138, 113);
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
//风险提示
.assess-dialog {
  padding: 0.8rem;
  width: 70vw;

  .btn-assess {
    width: 70%;
    color: @golden;
    font-size: @font-size-xxl;
    border-color: @golden;
    border-radius: 5px;
  }
}
//底部按钮
.buy-bg {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  font-size: 14px;
  height: 40px;
  .totale-amount {
    margin-left: 20px;
    color: #333333;
  }
  .buy {
    background-color: rgb(222, 47, 28);
    color: #ffffff;
    font-size: 14px;
    border: none;
    width: 90px;
    height: 100%;
    &.van-button--normal {
      border-radius: 0;
    }
    &.van-button--disabled {
      background-color: #d1d1d3;
      color: #ffffff;
      opacity: 1;
    }
  }
  .buy-no {
    background-color: rgb(199, 198, 201);
    color: #ffffff;
    font-size: 14px;
    border: none;
    width: 90px;
    height: 100%;
    &.van-button--normal {
      border-radius: 0;
    }
    &.van-button--disabled {
      background-color: #d1d1d3;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>
